import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlovenia = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 256,
			r: 256,
			fill: "#f0f0f0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0052b4",
			d: "M496 167H222.7v-66.8H89V167H16a255.4 255.4 0 0 0 0 178l240 22.3L496 345a255.5 255.5 0 0 0 0-178z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#d80027",
			d: "M256 512a256 256 0 0 0 240-167H16a256 256 0 0 0 240 167z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#f0f0f0",
			d: "M89 167v22.2c0 51.1 66.8 66.8 66.8 66.8s66.8-15.7 66.8-66.8V167l-22.3 22.2-44.5-33.4-44.5 33.4z"
		})
	]
});
export default SvgSlovenia;
